import { LoginForm } from "../LoginForm";
import MissionBriefing from "../MissionBriefing";
import { useEffect } from "react";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { useSelector } from "react-redux";

export const Home = () => {
  const state = useSelector((state) => state.reducer);
  const { setAudioURL } = useAudio();
  const { background2 } = useAudioList();


  useEffect(() => {
    setAudioURL(background2);
  }, [state.setAudio, setAudioURL]);

  return (
    <div className="relative flex justify-center items-center bg-blue-600 p-4 min-h-screen">
      <LoginForm />
      <MissionBriefing />
    </div>
  );
};
